import {
	mapGetters,
	mapActions
} from 'vuex';

import moment from 'moment';

export default {
	name: 'scheduled-medicine',
	computed: {
		...mapGetters({
			regularMedicines: 'getAgendaRegularMedicines',
			agendaDate: 'getAgendaDate'
		})
	},
	methods: {
		...mapActions([
			'putAgendaScheduledMedicine'
		]),
		getTimeDiff(time) {

			if (time) {

				const [year, month, date] = this.agendaDate.split('-');
				const [hour, minute] = time.split(':');

				return moment().diff(
					moment().set({
						year,
						month: (month - 1),
						date,
						hour,
						minute,
						second: 0
					})
				);

			}

		}
	}

};



// WEBPACK FOOTER //
// ./sources/domains/agenda/health/scheduled-medicine/index.js